<template>
  <div class="table-responsive text-nowrap">
    <a-table
      :columns="columns"
      :row-key="data.id"
      :data-source="data"
      :loading="loading"
    >
      <template #action="{text}">
        <span>
          <router-link
            class="btn btn-sm bg-holcim-bright-green text-white mr-2"
            :to="text.route"
          >
            <i class="fe fe-arrow-right mr-2" />
            Ir al catálogo
          </router-link>
        </span>
      </template>
    </a-table>
  </div>
</template>

<script>

const columns = [
  {
    title: 'Catálogos',
    dataIndex: 'name',
    class: 'text-center',
  },
  {
    title: 'Descripción',
    dataIndex: 'description',
    class: 'text-center',
  },
  {
    title: 'Acciones',
    slots: { customRender: 'action' },
    class: 'text-center',
  },
]

export default {
  name: 'CatalogTable',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    data: {
      type: [Object],
      require: true,
      defaultValue: {},
    },
    // eslint-disable-next-line vue/require-default-prop
    loading: {
      type: [Boolean],
      require: true,
      defaultValue: false,
    },
  },
  setup() {
    return {
      columns,
    }
  },
}
</script>
